export default {
  title: 'Agrupamiento de no conformidades',
  title_serviceOrder: 'Agrupamiento de no conformidades de actividades',
  title_formReply: 'Agrupamiento de no conformidades de formularios'
}
